<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<label
  class="checkbox-container"
  [class.disabled]="disabled"
  [class.no-border]="!showBorder"
>
  @if (!isStandaloneMode) {
    <!-- FormControl mode -->
    <input type="checkbox" [formControl]="formControl" />
  } @else {
    <!-- Standalone mode -->
    <input
      type="checkbox"
      [checked]="checked"
      [disabled]="disabled"
      (change)="onStandaloneChange($event)"
    />
  }
  <span class="checkmark"></span>
  <span class="label-text">{{ label }}</span>
</label>
